export default __webpack_public_path__ + "static/media/nodata.eb8530a2.png";